/** A statement's query string: its dates, then the matter it is narrowed to (the unpaid invoices statement only). */
export function statementPeriodQuery(options) {
    const params = new URLSearchParams();
    if (options?.from)
        params.set('from', options.from);
    if (options?.to)
        params.set('to', options.to);
    if (options?.clientProjectId)
        params.set('clientProjectId', options.clientProjectId);
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
